var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Spinner } from "components/authComponents/Spinner";
import NotFoundPage from "pages/notFoundPage/NotFoundPage";
import api from "shared/api/axios-instance";
import TokenService from "shared/api/token-service";
import { useLocaleStore } from "store/localeStore";
import { tokenHasAdminRole } from "./adminRole";
export var AdminGuard = function (_a) {
    var children = _a.children;
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var _c = useState(false), allowed = _c[0], setAllowed = _c[1];
    var locale = useLocaleStore(function (state) { return state.locale; });
    var setLocale = useLocaleStore(function (state) { return state.setLocale; });
    useEffect(function () {
        var checkRole = function () { return __awaiter(void 0, void 0, void 0, function () {
            var res, newAccessToken, _a;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (tokenHasAdminRole(TokenService.getAccessToken())) {
                            setAllowed(true);
                            setLoading(false);
                            return [2 /*return*/];
                        }
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, api.get("/auth/refresh-tokens")];
                    case 2:
                        res = _c.sent();
                        newAccessToken = (_b = res.data) === null || _b === void 0 ? void 0 : _b.accessToken;
                        if (newAccessToken) {
                            TokenService.setAccessToken(newAccessToken);
                            setAllowed(tokenHasAdminRole(TokenService.getAccessToken()));
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        _a = _c.sent();
                        setAllowed(false);
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        checkRole();
    }, []);
    if (loading)
        return _jsx(Spinner, {});
    if (!allowed) {
        return _jsx(NotFoundPage, { currentLocale: locale, onLocaleChange: setLocale });
    }
    return children;
};
